import { Star, User } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export const ReviewCard = ({ review }) => {
  return (
    <Card className="bg-slate-50 border-slate-100 h-full" data-testid={`review-card-${review.id}`}>
      <CardContent className="p-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0">
            <div className="w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center">
              <User className="w-6 h-6 text-blue-600" />
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2 mb-1">
              <h4 className="font-semibold text-slate-900 truncate">
                {review.author_name}
              </h4>
              <span className="text-xs text-slate-500 whitespace-nowrap">
                {review.relative_time}
              </span>
            </div>
            <div className="flex items-center gap-1 mb-3">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={`star-${i}`}
                  className={`w-4 h-4 ${
                    i < review.rating
                      ? "text-yellow-400 fill-yellow-400"
                      : "text-slate-300"
                  }`}
                />
              ))}
            </div>
            <p className="text-slate-600 text-sm leading-relaxed">
              {review.text}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
